import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import {AuthService} from "../../services/auth.service";
import Swal from "sweetalert2";
import {
    isEconetSubscriberValidator,
    validPhoneNumber
} from "../../utils/utils/validators/CustomValidators";

@Component({
    selector: 'app-resetpassword',
    templateUrl: './resetpassword.component.html',
    styleUrls: ['./resetpassword.component.css']
})
export class ResetpasswordComponent implements OnInit {
    resetForm!: FormGroup;
    isPasswordVisible: boolean = false;
    isVerified: boolean = false;
    noPhone: boolean = false;
    constructor(private fb: FormBuilder, private router: Router,
                private _authService: AuthService) {
    }

    ngOnInit(): void {
        this.resetForm = this.fb.group({
            identifier: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10), isEconetSubscriberValidator()]],
            password: ['', [Validators.required, Validators.minLength(6)]],
            confpassword: ['', [Validators.required, Validators.minLength(6)]],
          resetOtp: ['', [Validators.required]]
        });
    }

    onSubmit(): void {
        if (this.resetForm.valid) {
            const formValue = this.resetForm.value;
            const payload = {
                // email: this.isEmail(formValue.identifier) ? formValue.identifier : '',
                phoneNumber: this.isEmail(formValue.identifier) ? '' : formValue.identifier,
              resetOtp: formValue.resetOtp,
                password: formValue.password
            };

            this._authService.resetPassword(payload).subscribe(
                response => {
                    if (response.success) {
                        Swal.fire("Reset Password Success!", "Proceed next", "success").then(() =>
                            this.router.navigate(['/login']) // Redirect to login page or another page
                        );
                    } else {
                        Swal.fire("Reset Password Failed!", response.message, "error");
                    }
                },
                error => {
                    Swal.fire("Error occurred", error.message, "error");
                }
            );
        } else {
            this.resetForm.markAllAsTouched(); // This will trigger the display of all validation messages
        }
    }

    getOTP() {
        if (this.resetForm.value.identifier ==='' || !validPhoneNumber(this.resetForm.value.identifier)) {
            this.noPhone = true;
        }else{
            this.noPhone = false;
            console.log("Getting otp ... now");
            const formValue = this.resetForm.value;
            const payload = {
                // email: this.isEmail(formValue.identifier) ? formValue.identifier : '',
                phoneNumber: formValue.identifier,
            };
            this._authService.sendOTP(payload).subscribe(
                (data) => {
                    console.log(data);
                    if (data.success) {

                        Swal.fire("OTP Sent Successfully", "Check email or text message", "success");
                        this.isVerified = true;
                    } else {
                        Swal.fire("OTP resend Failed!", data.message, "error");
                        this.isVerified = false;
                    }
                },
                error => {
                    Swal.fire("Error occurred", error.message, "error");
                }
            );
        }

    }

    private isEmail(identifier: string): boolean {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailPattern.test(identifier);
    }

    routeToPage(page: string) {
        this.router.navigate([page])
    }


    togglePasswordVisibility(): void {
        this.isPasswordVisible = !this.isPasswordVisible;
      }

}
